import React, { useState } from 'react';

import './index.sass';

function Checkbox({ label, onInput }) {
    const [state, setState] = useState(false);

    function onClick () {
        let newState = !state;
        setState(newState);
        return onInput(newState);
    }

    return (
        <div className={`checkbox ${state ? '--active' : ''}`} onClick={onClick} >
            <span className="icon"></span>
            <p className="label">{label}</p>
        </div>
    );
};

export default Checkbox;
